import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between gap-4 border-b border-slate-200 px-6 py-4"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "px-6 py-5"
};
const _hoisted_4 = {
  class: "block"
};
const _hoisted_5 = {
  class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4"
};
import { computed, reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'InvoiceRegionModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    region: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      regionName: ''
    });
    const modalTitle = computed(() => props.region?.id ? '重命名区域' : '新增区域');
    function resetForm() {
      form.regionName = props.region?.regionName || '';
    }
    function close() {
      emit('update:modelValue', false);
    }
    function submit() {
      if (!form.regionName.trim()) {
        ElMessage.warning('请填写区域名称');
        return;
      }
      emit('submit', {
        id: props.region?.id || null,
        regionName: form.regionName.trim()
      });
    }
    watch(() => props.modelValue, value => {
      if (value) resetForm();
    });
    watch(() => props.region, () => {
      if (props.modelValue) resetForm();
    });
    return (_ctx, _cache) => {
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "md",
        "panel-class": "max-h-[92vh]",
        "z-index": 70,
        scrollable: false,
        onClose: close
      }, {
        default: _withCtx(() => [_createElementVNode("header", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(modalTitle.value), 1)]), _createElementVNode("button", {
          type: "button",
          class: "rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600",
          onClick: close
        }, [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
          class: "sr-only"
        }, "关闭", -1), _createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("main", _hoisted_3, [_createElementVNode("label", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "form-label"
        }, [_createTextVNode("区域名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.regionName = $event),
          type: "text",
          class: "form-input mt-1 w-full",
          placeholder: "请输入区域名称",
          onKeyup: _withKeys(submit, ["enter"])
        }, null, 544), [[_vModelText, form.regionName]])])]), _createElementVNode("footer", _hoisted_5, [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: close
        }, "取消"), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary",
          onClick: submit
        }, [...(_cache[3] || (_cache[3] = [_createTextVNode("保存", -1)]))])), [[_directive_permission, 'enterprise-invoice:region:manage']])])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};